<template>
  <div>
    <div class="d-flex">
      <slot></slot>
      <div class="collapse-button pl-2" @click="collapsed = !collapsed">
        <i class="fa fa-angle-left fa-2x" :class="collapsed ? '' : 'rotated'"></i>
      </div>
    </div>
    <div class="can-collapse" :class="collapsed ? 'is-collapsed' : ''">
      <slot name="collapsed-content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      collapsed: true
    };
  }
};
</script>

<style scoped lang="scss">
.can-collapse {
  overflow: hidden;
  max-height: 80px;
  transition: max-height .7s ease-in-out;
}

.is-collapsed {
  max-height: 0;
}

.collapse-button {
  .rotated {
    transform: rotate(-90deg);
  }

  i {
    cursor: pointer;
  }
}

// i:hover {
//   color:  lighten($blue, 20);
// }
</style>
